;(() => {
  if (location.hostname.startsWith('app.')) {
    import(/* webpackChunkName: "receptionist" */ './receptionist')
  } else {
    import(/* webpackChunkName: "looop" */ './looop')
  }
})()

export {}
